import { useConnectPersonioMutation, useSavePersonioMutation } from 'src/shared/api/integrations/personio';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useGetIntegrationDataQuery } from 'src/shared/api/integrations/factorial';
import { getIsConnected } from '../utils/getIsConnected';
import { useForm, useFormState } from 'react-final-form';
import { useGetCompaniesQuery } from 'src/shared/api/company';
import { isEmpty } from 'lodash';
import { addToast } from 'src/old/actions';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';
import { mapFormDataToPersonioConfig } from './utils';

const integrationName = 'personio';

export const usePersonioConnection = () => {
  const [selectedCompany, setSelectedCompany] = useState('');
  const [triggerConnection] = useConnectPersonioMutation();
  const { data: integrationData, isLoading } = useGetIntegrationDataQuery();
  const { data: companies } = useGetCompaniesQuery();
  const { values } = useFormState();
  const form = useForm();

  const isConnected = getIsConnected({
    isLoading,
    integrationData,
    subsidiary: values.subsidiary,
    integrationName
  });

  const handleSelectedCompanyChange = (newCompany: string) => {
    setSelectedCompany(newCompany);
  };

  const company = integrationData?.find(company => company.subsidiary === selectedCompany);

  useEffect(() => {
    if (!integrationData || !companies || !selectedCompany) {
      return;
    }

    if (company) {
      form.change('clientId', company?.credentials?.clientId);
      form.change('clientSecret', company?.credentials?.clientSecret);
      form.change('subcompany', company?.parameters?.subcompany);
      form.change('departments', company?.parameters?.departments);
      form.change('leaveTypes', company?.parameters?.leaveTypes);
      form.change('offices', company?.parameters?.offices);

      if (!isEmpty(company?.fieldMap?.fieldMapping)) {
        form.change('withCustomFields', true);
        form.change('customFields', company?.fieldMap?.fieldMapping);
      } else {
        form.change('withCustomFields', false);
        form.change('customFields', null);
      }
    } else {
      form.change('clientId', '');
      form.change('clientSecret', '');
      form.change('subcompany', '');
      form.change('departments', []);
      form.change('leaveTypes', []);
      form.change('offices', []);

      form.change('withCustomFields', false);
      form.change('customFields', null);
    }
  }, [integrationData, form, companies, selectedCompany, company]);

  return { handleSelectedCompanyChange, selectedCompany, triggerConnection, isConnected };
};

export const usePersonioSaveIntegration = () => {
  const [saveConfig] = useSavePersonioMutation();
  const dispatch = useDispatch();
  const { t } = useTranslation('superAdmin');

  const savePersonioIntegrationData = () => (formData: any) => async () => {
    try {
      const payload = mapFormDataToPersonioConfig(formData);
      await saveConfig(payload);
      dispatch(addToast({ ...toastTypes.success, defaultMessage: t('toasts.updated') }));
    } catch (error) {
      console.error(error);
    }
  };

  return savePersonioIntegrationData;
};
